import { useState } from 'react';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { routes } from '@shared/constants/paths';
import { MultiDocumentAgentTemplateType } from '@utils/enums';

function MultiDocumentAgentCreateButton() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDocumentTypeSelect = (
    documentType: MultiDocumentAgentTemplateType
  ) => {
    if (documentType === MultiDocumentAgentTemplateType.DEMAND_LETTER) {
      navigate(routes.superAdmin.multiDocumentAgent.demandLetter.create);
    } else if (
      documentType === MultiDocumentAgentTemplateType.DEPOSITION_SUMMARY
    ) {
      navigate(routes.superAdmin.multiDocumentAgent.depositionSummary.create);
    } else if (documentType === MultiDocumentAgentTemplateType.CUSTOM_GPT) {
      // navigate(routes.superAdmin.multiDocumentAgent.customGpt.create); // Hidden for now
    } else if (documentType === MultiDocumentAgentTemplateType.USE_CASE) {
      navigate(routes.superAdmin.multiDocumentAgent.useCase.create);
    }
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'document-type-popover' : undefined;

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleClick}
        sx={{
          flexGrow: { xs: 1, sm: 0 },
        }}
        aria-describedby={id}
      >
        Create Multi-document Agent
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List sx={{ width: '210px', padding: 0 }}>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() =>
                handleDocumentTypeSelect(
                  MultiDocumentAgentTemplateType.DEMAND_LETTER
                )
              }
            >
              <ListItemText primary="Demand Letter" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() =>
                handleDocumentTypeSelect(
                  MultiDocumentAgentTemplateType.DEPOSITION_SUMMARY
                )
              }
            >
              <ListItemText primary="Deposition Summary" />
            </ListItemButton>
          </ListItem>
          {/* <ListItem disablePadding>
            <ListItemButton
              onClick={() =>
                handleDocumentTypeSelect(
                  MultiDocumentAgentTemplateType.CUSTOM_GPT
                )
              }
            >
              <ListItemText primary="Custom GPT" />
            </ListItemButton>
          </ListItem> */}{' '}
          {/* Hidden for now */}
          <ListItem disablePadding>
            <ListItemButton
              onClick={() =>
                handleDocumentTypeSelect(
                  MultiDocumentAgentTemplateType.USE_CASE
                )
              }
            >
              <ListItemText primary="Use Case" />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
    </>
  );
}

export default MultiDocumentAgentCreateButton;
